import config from 'react-global-configuration';

(function clientJS() {
    config.set(window.__INITIAL_CONFIG__);
}());